var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.descriptions),function(description,index){return _c('div',{key:index},[_c('h4',[_vm._v(_vm._s(_vm.descriptionTypeLabel(description)))]),_vm._v(" "),_vm._l((description.descriptions),function(text,textIndex){return _c('div',{key:textIndex,staticClass:"mb-2",domProps:{"innerHTML":_vm._s(text)}})})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }